export const STROKE_IDS = {
    '50 Freestyle': 1, '100 Freestyle': 2, '200 Freestyle': 3, '400 Freestyle': 4,
    '800 Freestyle': 5, '1500 Freestyle': 6,
    '50 Breaststroke': 7, '100 Breaststroke': 8, '200 Breaststroke': 9,
    '50 Butterfly': 10, '100 Butterfly': 11, '200 Butterfly': 12,
    '50 Backstroke': 13, '100 Backstroke': 14, '200 Backstroke': 15,
    '200 Individual Medley': 16, '400 Individual Medley': 17,
    '100 Individual Medley': 18, '150 Individual Medley': 19,
};
